import { apiEndpointBase } from "./endpoint.config";

const base = apiEndpointBase;

export default {
  unsubscribe: base + "unsubscribe",
};
